/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Role_Agent_DInputs */

const en_mk_sec_pg_role_agent_d = /** @type {(inputs: Mk_Sec_Pg_Role_Agent_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a human role. Its permissions are inherited from whoever triggered it, then narrowed again by the tool allowlist its owner set.`)
};

const id_mk_sec_pg_role_agent_d = /** @type {(inputs: Mk_Sec_Pg_Role_Agent_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukan peran manusia. Izinnya diturunkan dari orang yang memicunya, dipersempit lagi oleh daftar alat yang diizinkan pemiliknya.`)
};

/**
* | output |
* | --- |
* | "Not a human role. Its permissions are inherited from whoever triggered it, then narrowed again by the tool allowlist its owner set." |
*
* @param {Mk_Sec_Pg_Role_Agent_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_role_agent_d = /** @type {((inputs?: Mk_Sec_Pg_Role_Agent_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Role_Agent_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_role_agent_d(inputs)
	return en_mk_sec_pg_role_agent_d(inputs)
});